import React from 'react'
import styled from 'styled-components'

import Heading from 'components/Heading'

const SubHead = styled(Heading).attrs({ size: 5, variant: 'sans' })`
  margin-top: 1.25em;
`

const ProseSegments = ({ segments }) => (
  <>
    {segments.map((seg, i) =>
      seg.type === 'p' ? (
        <p key={i}>{seg.text}</p>
      ) : seg.type === 'h3' ? (
        <SubHead key={i}>{seg.text}</SubHead>
      ) : (
        <ul key={i}>
          {seg.items.map((item, j) => (
            <li key={j}>{item}</li>
          ))}
        </ul>
      )
    )}
  </>
)

export default ProseSegments
